export enum ThemeModes {
  Auto = 'auto',
  Light = 'light',
  Dark = 'dark',
}

export const initialThemeMode = ThemeModes.Auto;
